export const SITE = {
  email: 'danialdarabi.pm@gmail.com',
  phone: { display: '+49 152 2968 5624', href: 'tel:+4915229685624' },
  linkedin: 'https://linkedin.com/in/drdanial97',
  github: 'https://github.com/drdanial97',
  resume: '/Danial%20Darabi%20Resume%20Sep%202026.pdf',
};
